import { render, staticRenderFns } from "./RelatorioCargaDescargaListFiltro.vue?vue&type=template&id=10f1be3f"
import script from "./RelatorioCargaDescargaListFiltro.vue?vue&type=script&lang=js"
export * from "./RelatorioCargaDescargaListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports